import WorkItemDisplay from '@/components/_accounts/profile/work-item'
import { useState } from 'react'

function WorkItem({ workSample }) {
  return (
    <div className="flex h-full flex-col gap-2">
      <div className="flex aspect-video flex-col">
        <WorkItemDisplay workSample={workSample} />
      </div>
    </div>
  )
}

export default function MyWorkSection({ workSamples }) {
  const [viewAll, setViewAll] = useState(false)
  if (!workSamples || workSamples.length === 0) return null

  return (
    <div className="flex w-full flex-col gap-4 rounded bg-neutral-blue-700 p-8 xl:gap-10">
      <div className="flex w-full flex-col gap-4">
        <div className="flex w-full items-center justify-center">
          <p className="text-center font-syncopate text-xl font-bold uppercase text-shades-0 desktop-sm:text-start desktop-sm:text-2xl">
            My Work
          </p>
          <div className="hidden flex-1 justify-end desktop-sm:flex">
            {workSamples?.length > 4 && (
              <button
                onClick={() => setViewAll(!viewAll)}
                className="text-sm text-shades-0 underline"
              >
                View all
              </button>
            )}
          </div>
        </div>
        <div className="grid flex-1 auto-cols-fr gap-4 desktop-sm:grid-cols-2">
          {workSamples?.length > 0 ? (
            workSamples
              .slice(0, viewAll ? workSamples?.length || 0 : 4)
              .map((workSample, workSampleIndex) => (
                <WorkItem
                  workSample={workSample}
                  key={`Work${workSampleIndex}`}
                />
              ))
          ) : (
            <div className="col-span-full grid flex-1 text-center">
              <p className="flex h-36 items-center justify-center text-center text-xl text-shades-0">
                No work shared yet
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
